import React from "react";
import Item from "./Item";
import cx from "classnames";
import styles from "./FeaturedItems.module.scss";
import { usePageContext } from "@providers/PageProvider";
import { dinningPage } from "@utils/helper";
import _ from "lodash";
export default function FeaturedItems() {
  const { pageData } = usePageContext();

  const headChef: any = dinningPage.formatHeadChefSection(pageData);
  return (
    <div
      data-scroll-section
      className={cx("flex flex-col items-center", styles.section)}
    >
      <Item
        className={cx(styles.item3)}
        images={[
          {
            ..._.get(headChef, "image", {}),
            alt: "image-dinning-item-4",
            placement: "left",
          },
        ]}
        aside={{
          placement: "right",
          className: cx(styles.asideItem3),
          content: {
            className: cx(styles.contentItem3),
            title: _.get(headChef, "title", ""),
            text: _.get(headChef, "description", ""),
          },
        }}
        showGetToKnow
        button={_.get(headChef, "button")}
      />
    </div>
  );
}
